var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewSubmission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 624.168,
    height: 471.738,
    viewBox: "0 0 624.168 471.738",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f86cda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1c2ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8184fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41427d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48168",
    "data-name": "Group 48168",
    transform: "translate(-115.611 -97.748)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1234",
    "data-name": "Ellipse 1234",
    cx: 234.604,
    cy: 234.604,
    r: 234.604,
    transform: "translate(198.659 100.279)",
    fill: "#dbe8ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94280",
    "data-name": "Path 94280",
    d: "M739.779,277.371V253.78a16.961,16.961,0,0,0-16.961-16.961H662.95a16.961,16.961,0,0,1-16.961-16.961v-23.59a16.961,16.961,0,0,1,16.961-16.961h1.89A16.961,16.961,0,0,0,681.8,162.346V138.757A16.961,16.961,0,0,0,664.84,121.8H229.875a16.961,16.961,0,0,0-16.961,16.961v23.59a16.961,16.961,0,0,0,16.961,16.961h0a16.961,16.961,0,0,1,16.961,16.961v23.59a16.961,16.961,0,0,1-16.961,16.961H164.286a16.961,16.961,0,0,0-16.961,16.96V277.37a16.961,16.961,0,0,0,16.961,16.961h25.736a16.961,16.961,0,0,1,16.961,16.961v23.59a16.961,16.961,0,0,1-16.961,16.961h-.062A16.961,16.961,0,0,0,173,368.8v23.59a16.961,16.961,0,0,0,16.961,16.961h3.724a16.961,16.961,0,0,1,16.961,16.961v23.59a16.961,16.961,0,0,1-16.961,16.961h-61.11a16.961,16.961,0,0,0-16.961,16.961v23.59a16.961,16.961,0,0,0,16.961,16.961H673.947a16.961,16.961,0,0,0,16.961-16.961V483.829a16.961,16.961,0,0,0-16.961-16.961H659.24a16.961,16.961,0,0,1-16.961-16.962V426.317a16.961,16.961,0,0,1,16.962-16.961h34.675a16.961,16.961,0,0,0,16.961-16.961V368.8a16.961,16.961,0,0,0-16.961-16.961H683.4a16.961,16.961,0,0,1-16.961-16.961v-23.59A16.961,16.961,0,0,1,683.4,294.331h39.42a16.961,16.961,0,0,0,16.962-16.961Z",
    transform: "translate(0 11.795)",
    fill: "#dbe8ec"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_243",
    "data-name": "Line 243",
    x2: 45.192,
    transform: "translate(529.273 127.204)",
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_244",
    "data-name": "Line 244",
    x2: 45.192,
    transform: "translate(529.273 140.229)",
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_245",
    "data-name": "Line 245",
    x2: 45.192,
    transform: "translate(529.273 153.254)",
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_246",
    "data-name": "Line 246",
    x2: 45.192,
    transform: "translate(560.58 489.733)",
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_247",
    "data-name": "Line 247",
    x2: 45.192,
    transform: "translate(560.58 502.758)",
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_248",
    "data-name": "Line 248",
    x2: 45.192,
    transform: "translate(560.58 515.783)",
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_249",
    "data-name": "Line 249",
    x2: 45.192,
    transform: "translate(185.538 274.294)",
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_250",
    "data-name": "Line 250",
    x2: 45.192,
    transform: "translate(185.538 287.319)",
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_251",
    "data-name": "Line 251",
    x2: 45.192,
    transform: "translate(185.538 300.344)",
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94281",
    "data-name": "Path 94281",
    d: "M612.774,401.868l-175.1,17.616-175.1-17.616a2.981,2.981,0,0,1-2.683-2.966l-4.126-12.068,4.126-197.715L437.674,207l177.781-17.885,3.923,199.324L615.456,398.9a2.981,2.981,0,0,1-2.682,2.966Z",
    transform: "translate(68.739 44.813)",
    fill: "#8184fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94282",
    "data-name": "Path 94282",
    d: "M619.378,392.784l-181.7,17.535L255.767,391.174l4.126-207.924a2.981,2.981,0,0,1,3.279-2.966l174.5,17.556,174.5-17.556a2.981,2.981,0,0,1,3.279,2.966Z",
    transform: "translate(68.74 40.473)",
    fill: "#a5a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94283",
    "data-name": "Path 94283",
    d: "M376.855,396.083l174.729-17L544.3,180.852,389.9,196.386Z",
    transform: "translate(128.128 40.759)",
    fill: "#8184fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94284",
    "data-name": "Path 94284",
    d: "M376.855,182.108,529.6,164.938l7.075,223.4L376.855,403.888Z",
    transform: "translate(128.128 32.954)",
    fill: "#8184fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94285",
    "data-name": "Path 94285",
    d: "M435.466,176.44l-160.611-2.862,8.585,217.487,143.441,8.585Z",
    transform: "translate(78.101 37.191)",
    fill: "#8184fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94286",
    "data-name": "Path 94286",
    d: "M377.815,174.188l152.742-17.17,10.731,223.926L377.815,395.968Z",
    transform: "translate(128.599 29.069)",
    fill: "#bebfed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94287",
    "data-name": "Path 94287",
    d: "M377.815,317.3v7.414l163.473-15.024-.353-7.381Z",
    transform: "translate(128.599 100.326)",
    fill: "#a5a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94288",
    "data-name": "Path 94288",
    d: "M430.666,169.48l-160.611-2.862,8.585,217.487,152.026,7.154Z",
    transform: "translate(75.747 33.778)",
    fill: "#8184fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94289",
    "data-name": "Path 94289",
    d: "M275.815,315.052l152.026,7.154v-7.637l-152.026-7.156Z",
    transform: "translate(78.572 102.831)",
    fill: "#a5a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94290",
    "data-name": "Path 94290",
    d: "M283.846,311.455a80.568,80.568,0,0,0,60.336,75.878l66.911,3.149V178.693s-50.557,3.59-102.979-11.4l-28.05-.5Z",
    transform: "translate(80.656 33.865)",
    fill: "#a5a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94291",
    "data-name": "Path 94291",
    d: "M457.385,387.277a121.044,121.044,0,0,0,50.592-104.508l-6.129-124.019L464.8,162.914c-33.863,17.144-75.272,27.89-75.272,27.89v202.71Z",
    transform: "translate(134.346 29.918)",
    fill: "#a5a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94292",
    "data-name": "Path 94292",
    d: "M377.815,186.194s85.492-22.178,111.248-53.656l7.2,145.622a121.051,121.051,0,0,1-92.912,123.745l-25.532,6.069Z",
    transform: "translate(128.599 17.063)",
    fill: "#bebfed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94293",
    "data-name": "Path 94293",
    d: "M400.543,174.506l-22.727,221.78s28.94-2.187,31.209-2.868c25.413-23.312,39.881-62.479,36.433-97.275L431.606,156.369c-9.2,3.774-18.212,7.041-26.158,9.721C402.534,171.157,400.543,174.506,400.543,174.506Z",
    transform: "translate(128.599 28.751)",
    fill: "#a5a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94294",
    "data-name": "Path 94294",
    d: "M377.815,186.194S402.5,144.7,405.359,132.538L422.73,307.83a110.368,110.368,0,0,1-44.915,100.143h0Z",
    transform: "translate(128.599 17.063)",
    fill: "#bebfed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94295",
    "data-name": "Path 94295",
    d: "M421.014,175.6s-70.469,5.008-131.279-21.463l4.032,154.225a80.578,80.578,0,0,0,65.225,77l62.022,12.016Z",
    transform: "translate(85.399 27.657)",
    fill: "#bebfed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94296",
    "data-name": "Path 94296",
    d: "M378.8,168.538c1.233,18.482,1.879,36.963,2.317,55.445.275,9.241.336,18.482.5,27.722l.165,27.722-.157,27.722c-.166,9.241-.219,18.482-.5,27.722-.437,18.482-1.085,36.963-2.326,55.445-1.241-18.482-1.889-36.963-2.326-55.445-.277-9.241-.33-18.482-.5-27.722l-.157-27.722.165-27.722c.162-9.241.223-18.482.5-27.722C376.917,205.5,377.563,187.02,378.8,168.538Z",
    transform: "translate(127.618 34.719)",
    fill: "#a5a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94297",
    "data-name": "Path 94297",
    d: "M307.967,189.493c7.517.636,14.889,1.541,22.257,2.406l22.019,2.637c7.329.863,14.654,1.583,22.006,2.3,7.36.7,14.717,1.134,22.251,1.776a104.854,104.854,0,0,1-22.4,2.909,163.411,163.411,0,0,1-22.543-1.067,187.752,187.752,0,0,1-22.172-3.961A132.214,132.214,0,0,1,307.967,189.493Z",
    transform: "translate(94.341 44.997)",
    fill: "#a5a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94298",
    "data-name": "Path 94298",
    d: "M307.967,210.848c7.517.636,14.889,1.541,22.257,2.406l22.019,2.637c7.329.863,14.654,1.583,22.006,2.3,7.36.7,14.717,1.134,22.251,1.776a104.857,104.857,0,0,1-22.4,2.909,163.424,163.424,0,0,1-22.543-1.067,187.758,187.758,0,0,1-22.172-3.961A132.217,132.217,0,0,1,307.967,210.848Z",
    transform: "translate(94.341 55.47)",
    fill: "#a5a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94299",
    "data-name": "Path 94299",
    d: "M307.967,232.2c7.517.636,14.889,1.541,22.257,2.406l22.019,2.637c7.329.863,14.654,1.583,22.006,2.3,7.36.7,14.717,1.134,22.251,1.776a104.853,104.853,0,0,1-22.4,2.909,163.4,163.4,0,0,1-22.543-1.067,187.76,187.76,0,0,1-22.172-3.961,132.215,132.215,0,0,1-21.421-7Z",
    transform: "translate(94.341 65.945)",
    fill: "#a5a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94300",
    "data-name": "Path 94300",
    d: "M307.967,253.559c7.517.636,14.889,1.541,22.257,2.406l22.019,2.637c7.329.863,14.654,1.583,22.006,2.3,7.36.7,14.717,1.134,22.251,1.776a104.854,104.854,0,0,1-22.4,2.909,163.41,163.41,0,0,1-22.543-1.067,187.762,187.762,0,0,1-22.172-3.961,132.217,132.217,0,0,1-21.421-7Z",
    transform: "translate(94.341 76.418)",
    fill: "#a5a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94301",
    "data-name": "Path 94301",
    d: "M307.967,274.915c7.517.636,14.889,1.541,22.257,2.406l22.019,2.637c7.329.863,14.654,1.583,22.006,2.3,7.36.7,14.717,1.134,22.251,1.776a104.854,104.854,0,0,1-22.4,2.909,163.419,163.419,0,0,1-22.543-1.067,187.771,187.771,0,0,1-22.172-3.961,132.215,132.215,0,0,1-21.421-7Z",
    transform: "translate(94.341 86.892)",
    fill: "#a5a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94302",
    "data-name": "Path 94302",
    d: "M462.151,203l-34.723,5.856a2.981,2.981,0,0,1-3.494-2.358l-1.152-25.082a2.981,2.981,0,0,1,2.358-3.494l35.168-7.228a2.981,2.981,0,0,1,3.494,2.358l.706,26.454A2.981,2.981,0,0,1,462.151,203Z",
    transform: "translate(150.626 35.749)",
    fill: "#a5a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94303",
    "data-name": "Path 94303",
    d: "M448.926,244.46,414.2,250.316a2.981,2.981,0,0,1-3.494-2.358l-1.152-25.082a2.981,2.981,0,0,1,2.358-3.494l35.168-7.228a2.981,2.981,0,0,1,3.494,2.358l.706,26.454a2.981,2.981,0,0,1-2.358,3.494Z",
    transform: "translate(144.14 56.084)",
    fill: "#a5a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94304",
    "data-name": "Path 94304",
    d: "M411.915,217.853a2.981,2.981,0,0,0-2.358,3.494l1.152,25.082a2.981,2.981,0,0,0,3.494,2.358l13.653-2.3-3.1-31.27Z",
    transform: "translate(144.14 57.612)",
    fill: "#8184fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94305",
    "data-name": "Path 94305",
    d: "M458.044,285.921l-34.723,5.856a2.981,2.981,0,0,1-3.494-2.359l-1.152-25.082a2.981,2.981,0,0,1,2.358-3.494l35.168-7.228a2.981,2.981,0,0,1,3.494,2.358l.706,26.454A2.981,2.981,0,0,1,458.044,285.921Z",
    transform: "translate(148.612 76.418)",
    fill: "#a5a7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94306",
    "data-name": "Path 94306",
    d: "M421.034,258.777a2.981,2.981,0,0,0-2.358,3.494l1.152,25.082a2.961,2.961,0,0,0,1.483,2.025,120.991,120.991,0,0,0,4.621-31.608Z",
    transform: "translate(148.612 78.484)",
    fill: "#8184fa"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1235",
    "data-name": "Ellipse 1235",
    cx: 19.316,
    cy: 19.316,
    r: 19.316,
    transform: "translate(389.063 507.288)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1236",
    "data-name": "Ellipse 1236",
    cx: 10.016,
    cy: 10.016,
    r: 10.016,
    transform: "translate(372.608 470.444)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1237",
    "data-name": "Ellipse 1237",
    cx: 14.308,
    cy: 14.308,
    r: 14.308,
    transform: "translate(433.833 476.167)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1238",
    "data-name": "Ellipse 1238",
    cx: 22.983,
    cy: 22.983,
    r: 22.983,
    transform: "translate(179.846 392.423)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1239",
    "data-name": "Ellipse 1239",
    cx: 11.971,
    cy: 11.971,
    r: 11.971,
    transform: "translate(146.94 387.065)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1240",
    "data-name": "Ellipse 1240",
    cx: 6.905,
    cy: 6.905,
    r: 6.905,
    transform: "translate(163.002 351.437)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1241",
    "data-name": "Ellipse 1241",
    cx: 16.554,
    cy: 16.554,
    r: 16.554,
    transform: "translate(191.58 346.674)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1242",
    "data-name": "Ellipse 1242",
    cx: 22.983,
    cy: 22.983,
    r: 22.983,
    transform: "translate(324.504 133.595)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1243",
    "data-name": "Ellipse 1243",
    cx: 11.971,
    cy: 11.971,
    r: 11.971,
    transform: "translate(336.448 97.748)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1244",
    "data-name": "Ellipse 1244",
    cx: 10.361,
    cy: 10.361,
    r: 10.361,
    transform: "translate(417.795 106.353)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1245",
    "data-name": "Ellipse 1245",
    cx: 6.905,
    cy: 6.905,
    r: 6.905,
    transform: "translate(383.555 99.741)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1246",
    "data-name": "Ellipse 1246",
    cx: 16.554,
    cy: 16.554,
    r: 16.554,
    transform: "translate(381.932 127.784)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24084",
    "data-name": "Rectangle 24084",
    width: 27.096,
    height: 27.096,
    transform: "translate(297.932 393.463) rotate(29.699)",
    fill: "#dbe8ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94307",
    "data-name": "Path 94307",
    d: "M363.372,356.5a93.627,93.627,0,1,0-131.136-18.4A93.627,93.627,0,0,0,363.372,356.5Zm-116.56-29.371a75.388,75.388,0,1,1,105.572,14.8,75.388,75.388,0,0,1-105.572-14.8Z",
    transform: "translate(47.944 44.321)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1247",
    "data-name": "Ellipse 1247",
    cx: 75.387,
    cy: 75.387,
    r: 75.387,
    transform: "translate(279.557 250.679)",
    fill: "#fff",
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94308",
    "data-name": "Path 94308",
    d: "M345.592,253.155a53.925,53.925,0,0,1-101.169,22.5",
    transform: "translate(63.176 76.22)",
    fill: "none",
    stroke: "#8184fa",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24085",
    "data-name": "Rectangle 24085",
    width: 49.364,
    height: 117.262,
    rx: 2,
    transform: "translate(274.869 411.427) rotate(29.699)",
    fill: "#bebfed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94309",
    "data-name": "Path 94309",
    d: "M217.668,426.131l55.143-96.68a2.981,2.981,0,0,0-1.113-4.066l-9.376-5.348a2.981,2.981,0,0,1,1.112,4.066l-55.144,96.68a2.981,2.981,0,0,1-4.066,1.113l9.377,5.348a2.981,2.981,0,0,0,4.067-1.113Z",
    transform: "translate(43.46 109.023)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94310",
    "data-name": "Path 94310",
    d: "M193.671,412.291l55.142-96.68a2.981,2.981,0,0,1,4.066-1.112l10.415,5.94-19.482-11.112a2.981,2.981,0,0,0-4.066,1.112L184.6,407.119a2.981,2.981,0,0,0,1.112,4.066l9.067,5.172a2.981,2.981,0,0,1-1.112-4.066Z",
    transform: "translate(33.645 103.578)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94311",
    "data-name": "Path 94311",
    d: "M198.292,384.993l18.218,10.391h0Z",
    transform: "translate(40.551 140.881)",
    fill: "#409cb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94312",
    "data-name": "Path 94312",
    d: "M2.981,0H55.9a2.981,2.981,0,0,1,2.981,2.981v8.856A19.637,19.637,0,0,1,39.242,31.474H19.637A19.637,19.637,0,0,1,0,11.837V2.981A2.981,2.981,0,0,1,2.981,0Z",
    transform: "translate(216.582 504.015) rotate(29.699)",
    fill: "#dbe8ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94313",
    "data-name": "Path 94313",
    d: "M189.185,385.4l4.388-7.693a2.981,2.981,0,0,1,4.066-1.113L235.163,398a3.012,3.012,0,0,0-.472-.336l-45.966-26.217a2.981,2.981,0,0,0-4.066,1.112l-4.388,7.693a19.637,19.637,0,0,0,7.328,26.785l7.943,4.53a19.621,19.621,0,0,1-6.357-26.164Z",
    transform: "translate(30.446 134.045)",
    fill: "#e8eeef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94314",
    "data-name": "Path 94314",
    d: "M228.159,402.436l4.388-7.693a2.981,2.981,0,0,0-1.112-4.066l-9.417-5.371a2.98,2.98,0,0,1,1.1,4.061l-4.388,7.693a19.637,19.637,0,0,1-26.786,7.328l-7.621-4.347.016.01,17.03,9.713A19.636,19.636,0,0,0,228.159,402.436Z",
    transform: "translate(33.702 141.034)",
    fill: "#bad5db"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewSubmission);
export default __webpack_public_path__ + "static/media/newSubmission.a82a4060556709f2d7f6d1319049ce0d.svg";
export { ForwardRef as ReactComponent };